/**
 * WorkflowsActionCard — Dashboard Build Engine P4 (2026-07-28).
 *
 * Second Business-OS action card: once the tenant has told us what needs to get
 * done (Business Profile Q4 "tasks"), offer to turn that into automations by
 * kicking off a Pi routine that uses the existing n8n tools (create_n8n_workflow
 * et al., confirm-gated via n8nAgentStore). Same shape as the data card — shared
 * ActionCard + startPiRoutine + buildWorkflowsSeed. §6 (Q4 → n8n).
 */
import { Workflow } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { ActionCard } from './ActionCard';
import { runBuildStep, buildWorkflowsSeed } from './buildEngine';

export function WorkflowsActionCard() {
  const tasksAnswer = useDashboardStore((s) => s.profile.tasks);
  const status = useDashboardStore((s) => s.buildState.workflows);
  const setBuildStepStatus = useDashboardStore((s) => s.setBuildStepStatus);

  // Nothing to automate until the tenant has answered the "tasks" question.
  if (!tasksAnswer.trim()) return null;

  return (
    <ActionCard
      testId="workflows-action-card"
      icon={<Workflow className="h-5 w-5" />}
      title="Set up your workflows"
      description="Turn the work that keeps your business running into automations."
      preview={tasksAnswer}
      previewTestId="workflows-action-preview"
      buttonLabel="Set up my workflows"
      buttonTestId="workflows-action-start"
      onAction={() => void runBuildStep('workflows', buildWorkflowsSeed(tasksAnswer))}
      status={status ?? 'todo'}
      onMarkDone={() => void setBuildStepStatus('workflows', 'done')}
      onReopen={() => void setBuildStepStatus('workflows', 'todo')}
    />
  );
}

export default WorkflowsActionCard;
